"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlateButtonAvatar = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _useId = require("../../helpers/useId");

var _useStyles = require("../../helpers/useStyles");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".c20aff550{padding:0 .25rem;display:flex;flex-shrink:0}");
var styles = {
  root: 'c20aff550'
};

var PlateButtonAvatar = function PlateButtonAvatar(props) {
  var classes = props.classes;
  var id = (0, _useId.useId)();
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cn.root
  }, /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("mask", {
    id: id,
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#CBCFD2"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#".concat(id, ")")
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#C1C9D2"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: 10.133,
    cy: 14.4,
    fill: "#A3ACB9",
    r: 8
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: 8,
    cy: 7.467,
    fill: "#fff",
    r: 2.667
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: 8,
    cy: 16,
    fill: "#fff",
    r: 4.8
  }))));
};

exports.PlateButtonAvatar = PlateButtonAvatar;
PlateButtonAvatar.propTypes = {
  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
PlateButtonAvatar.defaultProps = {
  classes: {}
};